export default "__VITE_ASSET__DzqxPAlD__"